import { useState } from "react";

const BRAND = "#FF6B35";

const WECHAT_METHOD = { key: "wechat" as const, icon: "ri-wechat-pay-line", label: "微信支付", desc: "微信扫码/快捷支付", color: "#07C160" };
const CREDIT_METHOD = { key: "credit_wechat" as const, icon: "ri-wechat-pay-line", label: "微信信用授权", desc: "微信芝麻信用免押金", color: "#07C160" };

export type PaymentMethod = typeof WECHAT_METHOD.key | typeof CREDIT_METHOD.key;
export type CreditMode = "wechat";

interface PaymentMethodListProps {
  method: PaymentMethod;
  onMethodChange: (m: PaymentMethod) => void;
  creditApplied?: boolean;
  creditGranted?: number;
  depositAmount?: number;
  onOpenCreditApply?: () => void;
}

export function PaymentMethodList({ method, onMethodChange, creditApplied, creditGranted, depositAmount, onOpenCreditApply }: PaymentMethodListProps) {
  const isCredit = method === "credit_wechat";

  return (
    <div className="space-y-3">
      {/* 普通支付 */}
      <div className="rounded-2xl overflow-hidden" style={{ background: "#fff" }}>
        <div className="px-4 pt-3.5 pb-2">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">普通支付</span>
        </div>
        <button
          onClick={() => onMethodChange("wechat")}
          className="w-full flex items-center gap-3 px-4 py-3.5 cursor-pointer transition-all"
          style={{ background: method === "wechat" ? "#FFF8F5" : "#fff" }}
        >
          <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: `${WECHAT_METHOD.color}15` }}>
            <i className={WECHAT_METHOD.icon} style={{ color: WECHAT_METHOD.color, fontSize: 22 }} />
          </div>
          <div className="flex-1 text-left">
            <div className="text-sm font-semibold text-gray-800">{WECHAT_METHOD.label}</div>
            <div className="text-xs text-gray-400">{WECHAT_METHOD.desc}</div>
          </div>
          <div
            className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: method === "wechat" ? BRAND : "transparent", border: method === "wechat" ? "none" : "2px solid #E5E7EB" }}
          >
            {method === "wechat" && <i className="ri-check-line text-white" style={{ fontSize: 12 }} />}
          </div>
        </button>
      </div>

      {/* 信用支付 - 暂时隐藏 */}
      {/*
      <div className="rounded-2xl overflow-hidden" style={{ background: "#fff" }}>
        <div className="px-4 pt-3.5 pb-2 flex items-center justify-between">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">信用支付</span>
          <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: "#FFF3EE", color: BRAND }}>免押金</span>
        </div>

        {/!* 信用状态 *!/}
        {creditApplied ? (
          <div className="mx-4 mb-3 px-3 py-2.5 rounded-xl flex items-center gap-2" style={{ background: "#ECFDF5" }}>
            <i className="ri-checkbox-circle-fill flex-shrink-0" style={{ color: "#10B981", fontSize: 16 }} />
            <div>
              <div className="text-xs font-semibold text-green-700">信用授权成功</div>
              <div className="text-xs text-green-600">已获免押额度 ¥{creditGranted.toLocaleString()}</div>
            </div>
          </div>
        ) : (
          <div className="mx-4 mb-3 px-3 py-2.5 rounded-xl flex items-center justify-between" style={{ background: "#FFF8F5", border: "1px solid #FFE0CC" }}>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line flex-shrink-0" style={{ color: BRAND, fontSize: 15 }} />
              <div className="text-xs" style={{ color: "#AA4A1A" }}>开通信用支付可免交押金 ¥{depositAmount}</div>
            </div>
            <button
              onClick={onOpenCreditApply}
              className="text-xs font-semibold px-2.5 py-1 rounded-full cursor-pointer whitespace-nowrap"
              style={{ background: BRAND, color: "#fff" }}
            >
              去开通
            </button>
          </div>
        )}

        <button
          onClick={() => onMethodChange("credit_wechat")}
          className="w-full flex items-center gap-3 px-4 py-3.5 cursor-pointer transition-all"
          style={{ background: method === "credit_wechat" ? "#FFF8F5" : "#fff" }}
        >
          <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: `${CREDIT_METHOD.color}15` }}>
            <i className={CREDIT_METHOD.icon} style={{ color: CREDIT_METHOD.color, fontSize: 22 }} />
          </div>
          <div className="flex-1 text-left">
            <div className="text-sm font-semibold text-gray-800">{CREDIT_METHOD.label}</div>
            <div className="text-xs text-gray-400">{CREDIT_METHOD.desc}</div>
          </div>
          <div
            className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ background: method === "credit_wechat" ? BRAND : "transparent", border: method === "credit_wechat" ? "none" : "2px solid #E5E7EB" }}
          >
            {method === "credit_wechat" && <i className="ri-check-line text-white" style={{ fontSize: 12 }} />}
          </div>
        </button>
      </div>
      */}
    </div>
  );
}
